import ClientsAxios from '../client-axios';
import { ResponseEntity } from '../dto/response';
import { CheckStorage } from './storage.service';

const { API_SERVER } = ClientsAxios;


export const AudioUploadService = async (agentName: string, audioFile?: File) => {
    const responseEntity = new ResponseEntity<any>();
    const formData = new FormData();
    formData.append("agent_name", agentName);

    if (audioFile) {
        formData.append("file", audioFile);
    }

    try {
        // Retrieve the token from localStorage
        const token = localStorage.getItem('access_token');
        console.log('Token:', token); // Log the token

    
        // Check if the token exists
        if (!token) {
            throw new Error('No access token found');
        }
    
        const response = await API_SERVER.post('process_call', formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": `Bearer ${token}` // Ensure there's no extra space
            },
        });
        responseEntity.success(response.data.body, 200, response.data.message);
        return response.data.body; 
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.StatusCode || 500, error.Message, response.data && response.data.body ? response.data.body : null)
    }
};

export const evaluationListingService = async (
    searchQuery: string | undefined,
    page: number,
    rowsPerPage: number
) => {
    const responseEntity = new ResponseEntity<any>();
    try {
        // Create the payload based on the request body requirements
        const payload: { [key: string]: any } = {
            name: searchQuery || "",  // If searchQuery is undefined, send an empty string
            offset: page * rowsPerPage,
            limit: rowsPerPage,
        };

        // Send the POST request to the specified API URL
        const response = await API_SERVER.post('/listing', payload);
        // Handle the success response
        console.log(payload)
        console.log(response.data.Body.data)
        responseEntity.success(response.data.Body.data, 200, response.data.message);
        return {
            records: response.data.Body.data,
            total_count: response.data.Body.total_count,
        };
    } catch (error: any) {
        // Handle the error response
        CheckStorage(error.response.data.Message,error.response.data.StatusCode)
        const response = error.response || {};
        responseEntity.error(
            response.status || 500,
            error.message || "Unknown error",
            response.data && response.data.body ? response.data.body : null
        );
        return null;
    }
};




export const getTrendingTopicsService = async (startDate: string, endDate: string) => {
    const responseEntity = new ResponseEntity<any>();
    try {
        const response = await API_SERVER.get('top-topics', {
            params: {
                start_date: startDate,
                end_date: endDate,
            },
        });

        responseEntity.success(response.data.body.records, 200, response.data.message);
        return {
            records: response.data.body.records,
            totalCount: response.data.body.totalCount,
        };
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.StatusCode || 500, error.Message, response.data && response.data.body ? response.data.body : null)
    }
};


export const getPerformaceAverageService = async () => {
    const responseEntity = new ResponseEntity<any>();
    try {
        const response = await API_SERVER.get('average_scores_by_agent', {
            params: {

            },
        });

        responseEntity.success(response.data.body.records, 200, response.data.message);
        return {
            average_scores: response.data.body.average_scores,
            totalCount: response.data.body.totalCount,
        };
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.StatusCode || 500, error.Message, response.data && response.data.body ? response.data.body : null)
    }
};

//total-records-agents

export const getTotalRecordsService = async (startDate: string, endDate: string) => {
    const responseEntity = new ResponseEntity<any>();
    try {
        const response = await API_SERVER.post('/dashboard', {
            start_date: startDate,
            end_date: endDate,
        });
        
        if (response.data.StatusCode === 200) {
            responseEntity.success(response.data.Body.total_data, 200, response.data.Message);
            return {
                total_records: response.data.Body.total_data.total_count,
                total_agents: response.data.Body.total_data.agent_count,
                total_audio_duration: response.data.Body.total_data.total_min,
                total_audio_min: response.data.Body.total_data.total_min,
                average_duration: parseFloat(response.data.Body.total_data.average_duration) || 0,
                top_performance: response.data.Body.performers.top_performer,
                low_performance: response.data.Body.performers.low_performer,
            };
        } else {

            throw new Error(response.data.Message || "Failed to fetch data");
        }
    } catch (error: any) {
        CheckStorage(error.response.data.Message,error.response.data.StatusCode)
        const response = error.response || {};
        responseEntity.error(
            response.status || 500,
            error.message || 'An error occurred',
            response.data && response.data.body ? response.data.body : null
        );
    }
};



//sentiment-counts

export const getSentimentCountService = async () => {
    const responseEntity = new ResponseEntity<any>();
    try {
        const response = await API_SERVER.get('sentiment-counts', {
            params: {

            },
        });

        responseEntity.success(response.data.body.records, 200, response.data.message);
        return {
            sentiment_counts: response.data.body.sentiment_counts,
        };
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.StatusCode || 500, error.Message, response.data && response.data.body ? response.data.body : null)
    }
};


//all-average-scores

export const getAllAgentsAverageScore = async () => {
    const responseEntity = new ResponseEntity<any>();
    try {
        const response = await API_SERVER.get('all-average-scores', {
            params: {

            },
        });

        responseEntity.success(response.data.body.records, 200, response.data.message);
        return {
            agent_average_scores: response.data.body.agent_average_scores,
        };
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.StatusCode || 500, error.Message, response.data && response.data.body ? response.data.body : null)
    }
};

//weekly-average-scores



export const getAgentWeeklyAverageTotalScores= async () => {
    const responseEntity = new ResponseEntity<any>();
    try {
        const response = await API_SERVER.get('weekly-average-scores', {
            params: {

            },
        });

        responseEntity.success(response.data.body.records, 200, response.data.message);
        return {
            agent_weekly_average_total_scores: response.data.body.agent_weekly_average_total_scores,
        };
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.StatusCode || 500, error.Message, response.data && response.data.body ? response.data.body : null)
    }
};

//get_audio


export const getAudioById = async (unique_filename: string) => {
    const responseEntity = new ResponseEntity<any>();
    try {
        const response = await API_SERVER.get(`/file/download/${unique_filename}`, { responseType: 'blob' });
      console.log("getAudioById: ",response)
        responseEntity.success(response.data, 200, "Audio fetched successfully");
        return {
            body: response.data,  // This will be the blob data
        };
    } catch (error: any) {
        CheckStorage(error.response.data.Message,error.response.data.StatusCode)
        const response = error.response || {};
        responseEntity.error(response.StatusCode || 500, error.Message, response.data ? response.data : null);
    }
};





export const getAgentCallDuration = async (startDate: string, endDate: string,agent_name:string) => {
    const responseEntity = new ResponseEntity<any>();
    try {
        const response = await API_SERVER.get('call-duration', {
            params: {
                start_date: startDate,
                end_date: endDate,
                agent_name : agent_name
            },
        });

        responseEntity.success(response.data.body.records, 200, response.data.message);
        return {
            total_duration: response.data.body.total_duration,
            total_calls: response.data.body.total_calls,
        };
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.StatusCode || 500, error.Message, response.data && response.data.body ? response.data.body : null)
    }
};

export const getAgentListDropdownService = async () => {
    const responseEntity = new ResponseEntity<any>();
    try {
        const response = await API_SERVER.get('agent-list', {

        });

        responseEntity.success(response.data.body.records, 200, response.data.message);
        return {
            agents: response.data.body.agents,
        };
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.StatusCode || 500, error.Message, response.data && response.data.body ? response.data.body : null)
    }
};






